import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, ArrowContainer } from "react-tiny-popover";
import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { Link } from "react-router-dom";

const PopoverMenu = ({ links }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <>
      <Popover
        isOpen={isPopoverOpen}
        positions={["left", "bottom", "top", "right"]}
        onClickOutside={() => setIsPopoverOpen(false)}
        content={({ position, childRect, popoverRect }) => (
          <ArrowContainer
            position={position}
            childRect={childRect}
            popoverRect={popoverRect}
            arrowSize={8}
            arrowClassName="popover-arrow"
          >
            <div
              className="popover-content"
              onClick={() => setIsPopoverOpen(!isPopoverOpen)}
            >
              {links.map((l, k) => (
                <div className={l.class} key={k}>
                  {l.link instanceof Function ? (
                    <div onClick={l.link} className={l.class}>
                      {l.icon && (
                        <FontAwesomeIcon icon={l.icon} className="mr-2" />
                      )}
                      {l.label}
                    </div>
                  ) : (
                    <Link to={l.link}>
                      {l.icon && (
                        <FontAwesomeIcon icon={l.icon} className="mr-2" />
                      )}
                      {l.label}
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </ArrowContainer>
        )}
      >
        <button
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
          className="px-2 cursor-pointer"
        >
          <FontAwesomeIcon icon={faEllipsisVertical} size="lg" />
        </button>
      </Popover>
    </>
  );
};

export default PopoverMenu;
